import { trackCsEvent } from 'app/client/analytics';
import { getEnvelope } from 'app/client/analytics/utils';

// https://dataportal.zillowgroup.net/event-registry/5984
export const emitTrackNextClickExplorePageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5984',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'button_to_next_page_srp',
      trigger_object_nm: 'search_results|explore',
    },
    semantic: {
      semantic_event_nm: 'explore_next_page',
      topic_tag_txt: [],
    },
  });
};

type TriggerLocation = 'user_item_viewed_page' | 'user_item_hidden_page' | 'user_item_list_page' | 'search_results';
type TriggerObject = 'user_item_page|header' | 'search_results|header';

// https://dataportal.zillowgroup.net/event-registry/5989
export const emitTrackSortListingsEvent = ({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: TriggerLocation;
  triggerObject: TriggerObject;
}) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5989',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'sort_by_dropdown',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'sort_order_changed',
      topic_tag_txt: [],
    },
  });
};

export type SuggestedAreaTriggerLocation = 'search_results' | 'hp_homepage';
export type SuggestedAreaTriggerObject = 'hp_home_page_component|search' | 'filter_panel';

// https://dataportal.zillowgroup.net/event-registry/5929
export const emitTrackSuggestedAreaEvent = ({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: SuggestedAreaTriggerLocation;
  triggerObject: SuggestedAreaTriggerObject;
}) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5929',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'autocomplete_box',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'search_select_area_suggestion',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/9345
type ViewModeTarget = 'list' | 'feed' | 'map';

export const emitTrackToggleViewModeEvent = ({ targetView }: { targetView: ViewModeTarget }) => {
  const triggerSourceMap: Record<ViewModeTarget, string> = {
    list: 'button_to_view_list',
    feed: 'button_to_view_feed',
    map: 'button_to_view_map',
  };

  trackCsEvent({
    envelope: getEnvelope({
      eventId: '9345',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: triggerSourceMap[targetView],
      trigger_object_nm: 'search_results_component|view_mode_toggle',
    },
    semantic: {
      semantic_event_nm: 'toggle_view_mode',
      topic_tag_txt: [],
    },
  });
};
